'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _ComponentWithWindowListeners = require('../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _MeasureText = require('../utils/MeasureText');

var _UITextArea = require('./UITextArea');

var _UITextArea2 = _interopRequireDefault(_UITextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIExpandingTextArea',

  mixins: [_ComponentWithWindowListeners2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _UITextArea2.default.propTypes, {
    counter: _react.PropTypes.bool,
    defaultValue: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    maxHeight: _react.PropTypes.number.isRequired,
    minHeight: _react.PropTypes.number.isRequired,
    onChange: _react.PropTypes.func,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    shrink: _react.PropTypes.bool.isRequired,
    style: _react.PropTypes.object,
    value: _react.PropTypes.string
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UITextArea2.default.defaultProps, {
      maxHeight: Infinity,
      minHeight: 0,
      shrink: false
    });
  },
  getInitialState: function getInitialState() {
    return {
      height: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.setHeight();
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (!(0, _underscore.isEqual)(prevProps, this.props)) {
      this.setHeight();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.cancelAnimationFrame();
  },
  getWindowListeners: function getWindowListeners() {
    return {
      resize: this.handleWindowResize
    };
  },
  handleWindowResize: function handleWindowResize() {
    this.requestAnimationFrame(this.setHeight);
  },
  cancelAnimationFrame: function cancelAnimationFrame() {
    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId);
      this.requestId = null;
    }
  },
  focus: function focus() {
    if (this.refs.uitextarea) {
      this.refs.uitextarea.focus();
    }
  },
  select: function select() {
    if (this.refs.textarea) {
      this.refs.textarea.select();
    }
  },
  getTextAreaNode: function getTextAreaNode() {
    return this.refs.uitextarea && this.refs.uitextarea.getTextArea();
  },
  handleChange: function handleChange(evt) {
    this.setHeight();
    var onChange = this.props.onChange;

    (0, _Functions.callIfPossible)(onChange, evt);
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    this.cancelAnimationFrame();
    this.requestId = window.requestAnimationFrame(callback);
  },
  setHeight: function setHeight() {
    var _this = this;

    var textAreaNode = this.getTextAreaNode();
    if (!textAreaNode) {
      return;
    }
    textAreaNode.scrollTop = 0;
    this.requestAnimationFrame(function () {
      var newHeight = (0, _MeasureText.getTextHeight)(textAreaNode);
      var _props = _this.props,
          minHeight = _props.minHeight,
          shrink = _props.shrink;
      var height = _this.state.height;

      if (shrink || newHeight > height) {
        _this.setState({
          height: Math.max(newHeight, minHeight)
        });
      }
    });
  },
  getStyle: function getStyle(_ref) {
    var maxHeight = _ref.maxHeight,
        style = _ref.style;

    return _extends({}, style, {
      height: this.state.height,
      maxHeight: maxHeight,
      overflow: this.state.height > maxHeight ? 'auto' : 'hidden',
      resize: 'none'
    });
  },
  render: function render() {
    var propsNotUsedInRender = ['minHeight', 'onChange', 'shrink'];

    var _omit = (0, _underscore.omit)(this.props, propsNotUsedInRender),
        counter = _omit.counter,
        maxHeight = _omit.maxHeight,
        style = _omit.style,
        rest = _objectWithoutProperties(_omit, ['counter', 'maxHeight', 'style']);

    return _react2.default.createElement(_UITextArea2.default, _extends({}, rest, {
      _textAreaHeightStyle: this.getStyle({ maxHeight: maxHeight, style: style }),
      counter: counter,
      onChange: this.handleChange,
      ref: 'uitextarea'
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/input/UIExpandingTextArea.js
// module id = 246
// module chunks = 0 1